import React, { useEffect } from "react";

import { connect } from "react-redux";

import get from "lodash/get";
import indexOf from "lodash/indexOf";

import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";

import Copyright from "../../../../components/Copyright";
import Markdown from "../shared/md";
import PageImage from "../shared/PageImage/index";
import { getPageContent } from "../shared/selectors";
import { OUTRO_PAGE } from "../types";
import { gaPageView } from "../../../../utils/analytics";

const styles = theme => ({
  container: {
    padding: "200px 80px 80px 80px",
    [theme.breakpoints.down("xs")]: {
      padding: "80px 24px 24px 24px"
    }
  },
  contentWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  image: {
    [theme.breakpoints.up("xl")]: {
      justifyContent: "center"
    }
  },
  content: {
    maxWidth: 450
  }
});

const panelists = ["bilendi", "borderless", "branded", "catalyst_mr", "cint", "dataspring", "empanel", "forsker", "globalsurvey", "gmo_research", "luthresearch", "question_lab", "symmetric", "torfac"];

const getUrl = (survey, locale, member_id, ext_uuid, completed) => {
  if (survey === "dn25" && member_id === "bilendi" && locale === "en") {
    const url =
      completed
        ? `https://survey.maximiles.com/complete?p=108321_6313ff93&m=${ext_uuid}`
        : `https://survey.maximiles.com/screenout?p=108321_5564453f&m=${ext_uuid}`;

    return url;
  }

  if (survey === "dn25" && member_id === "bilendi" && locale === "es") {
    const url =
      completed
        ? `https://survey.maximiles.com/complete?p=108321_d56ae05a&m=${ext_uuid}`
        : `https://survey.maximiles.com/screenout?p=108321_76174231&m=${ext_uuid}`;

    return url;
  }

  if (survey === "dn25" && member_id === "bilendi" && locale === "fr") {
    const url =
      completed
        ? `https://survey.maximiles.com/complete?p=108321_efd09547&m=${ext_uuid}`
        : `https://survey.maximiles.com/screenout?p=108321_462a3f4f&m=${ext_uuid}`;

    return url;
  }

  if (member_id === "borderless") {
    const url =
      completed
        ? `https://surveys.thepanelstation.com/crdct.aspx?route=${ext_uuid}A28D49B168410E78`
        : `https://surveys.thepanelstation.com/crdct.aspx?route=${ext_uuid}2E32549167C36C23`;

    return url;
  }

  if (member_id === "branded") {
    const url =
      completed
        ? `https://r.mintvine.com/success/?uid=${ext_uuid}`
        : `https://r.mintvine.com/nq/?uid=${ext_uuid}`;

    return url;
  }

  if (member_id === "catalyst_mr") {
    const url =
      completed
        ? `https://www.cmrpanel.com/surveys/lp.php?CMRS=10&CMRID=${ext_uuid}`
        : `https://www.cmrpanel.com/surveys/lp.php?CMRS=20&CMRID=${ext_uuid}`;

    return url;
  }

  if (survey === "dn25" && member_id === "cint") {
    const url =
      completed
        ? `https://s.cint.com/Survey/Complete?ProjectToken=1fed4f26-66b2-4498-a8c9-a9aa5791714a`
        : `https://s.cint.com/Survey/EarlyScreenOut?ProjectToken=3b28780d-6bfd-f1dc-ba84-dcb708946831`;

    return url;
  }

  if (member_id === "cint") {
    const url =
      completed
        ? `https://s.cint.com/Survey/Complete?ProjectToken=5e3fbfac-4931-4938-a28b-8c6f3d2a47a7`
        : `https://s.cint.com/Survey/EarlyScreenOut?ProjectToken=ef50eb59-6a81-21ab-477d-59dda6bf1b9b`;

    return url;
  }

  if (survey === "dn25" && member_id === "dataspring") {
    const url =
      completed
        ? `https://d8aspring.post-survey.com/ans/back/?key=doI70Gmx&status=comp`
        : `https://d8aspring.post-survey.com/ans/back/?key=doI70Gmx&status=scrout`;

    return url;
  }

  if (member_id === "dataspring") {
    const url =
      completed
        ? `https://d8aspring.post-survey.com/ans/back/?key=e1JKN18k&status=comp`
        : `https://d8aspring.post-survey.com/ans/back/?key=e1JKN18k&status=scrout`;

    return url;
  }

  if (survey === "dn25" && member_id === "empanel") {
    const url =
      completed
        ? `https://bizpinionsurveys.com/endlink2.php?t=n&sr=r8a3S1awOu2yJ8bd6&id=${ext_uuid}`
        : `https://bizpinionsurveys.com/endlink2.php?t=n&sr=r8a3S1Ql98tVjU3e6&id=${ext_uuid}`;

    return url;
  }

  if (survey === "cnwa1" && member_id === "empanel") {
    const url =
      completed
        ? `https://bizpinion.com/endlink2.php?t=n&sr=pTd5R1XtPu2yJ8bd6&id=${ext_uuid}`
        : `https://bizpinion.com/endlink2.php?t=n&sr=pTd5R1NiA8tVjU3e6&id=${ext_uuid}`;

    return url;
  }

  if (member_id === "forsker") {
    const url =
      completed
        ? `https://forskerpartners.com/simpleProcess.php?status=1&pid=${ext_uuid}`
        : `https://forskerpartners.com/simpleProcess.php?status=2&pid=${ext_uuid}`;

    return url;
  }

  if (member_id === "globalsurvey") {
    const url =
      completed
        ? `https://www.gowebsurveys.com/surveyProcess.php?authToken=36e19e554b0859e5a3979d185125f3a6&pid=${ext_uuid}`
        : `https://www.gowebsurveys.com/surveyProcess.php?authToken=2063fd0cd56d761221b5391fcde27891&pid=${ext_uuid}`;

    return url;
  }

  if (survey === "dn25" && member_id === "gmo_research") {
    const url =
      completed
        ? `https://infopanel.jp/lpark/enqInfoUpdateForNC.do?status=1&id=${ext_uuid}`
        : `https://infopanel.jp/lpark/enqInfoUpdateForNC.do?status=2&id=${ext_uuid}`;

    return url;
  }

  if (member_id === "gmo_research") {
    const url =
      completed
        ? `https://infopanel.jp/lpark/enqInfoUpdateForNC.do?status=1&id=${ext_uuid}`
        : `https://infopanel.jp/lpark/enqInfoUpdateForNC.do?status=2&id=${ext_uuid}`;

    return url;
  }

  if (member_id === "luthresearch") {
    const url =
      completed
        ? `https://pt.surveysavvy.com/survey/finish/9107/5`
        : `https://pt.surveysavvy.com/survey/finish/9107/4`;

    return url;
  }

  if (survey === "cnwa1" && member_id === "question_lab") {
    const url =
      completed
        ? `https://vault.questionlab.com/audience/passback?creference=TVRnMEl5TmhZbU09&status=1&arid=${ext_uuid}`
        : `https://vault.questionlab.com/audience/passback?creference=TVRnMEl5TmhZbU09&status=2&arid=${ext_uuid}`;

    return url;
  }

  if (member_id === "symmetric") {
    const url =
      completed
        ? `https://www.daisurvey.com/surveyV3/RenderSurvey.aspx?SurveyID=gsuguhKlGRzTRU5yq%2fMMxA%3d%3d&PayCode=1&ID=${ext_uuid}`
        : `https://www.daisurvey.com/surveyV3/RenderSurvey.aspx?SurveyID=gsuguhKlGRzTRU5yq%2fMMxA%3d%3d&PayCode=2&ID=${ext_uuid}`;

    return url;
  }

  if (survey === "dn25" && member_id === "torfac") {
    const url =
      completed
        ? `https://pollrouting.com/return/YiTo271d6b272964e3c1c21a9feadaa65d4c22e/08b46e20b1507e7b36bd618e4b2ab1d6.php?sd=s&ct=6N234CTP30O6&wspid=${ext_uuid}`
        : `https://samplicity.wisesample.com/return/curlhandler.php?token=6d76e7ebbcb8ade97921f9ec17eb9246&e=r&wspid=${ext_uuid}`;

    return url;
  }

  if (member_id === "torfac") {
    const url =
      completed
        ? `https://pollrouting.com/return/YiTo271d6b272964e3c1c21a9feadaa65d4c22e/08b46e20b1507e7b36bd618e4b2ab1d6.php?sd=s&ct=6N234CTP30O6&wspid=${ext_uuid}`
        : `https://samplicity.wisesample.com/return/curlhandler.php?token=6d76e7ebbcb8ade97921f9ec17eb9246&e=r&wspid=${ext_uuid}`;

    return url;
  }

  return "";
};

const OutroPage = ({ classes, content, Images, survey, locale, member_id, ext_uuid, completed }) => {
  useEffect(() => {
    gaPageView();
  }, []);

  const isPanelist = indexOf(panelists, member_id) !== -1;

  if (isPanelist) {
    const url = getUrl(survey, locale, member_id, ext_uuid, completed);

    const panelistContent = `##### Thank you for your response. \n\n\n Click below to go to your panel \n\n\n\n[Click Me](${url} "button")`;
    return (
      <Grid container spacing={16} className={classes.container}>
        <Grid item xs={12} className={classes.contentWrapper}>
          <Markdown content={panelistContent} className={classes.content} />
        </Grid>
        <Grid item xs={12}>
          <Copyright />
        </Grid>
      </Grid>
    );
  }

  const { OutroAsset } = Images;

  return (
    <Grid container spacing={16} className={classes.container}>
      <Grid item xs={12} className={classes.contentWrapper}>
        <PageImage
          asset={OutroAsset}
          alt="outro-img"
          className={classes.image}
        />
        <Markdown content={content} className={classes.content} />
      </Grid>
      <Grid item xs={12}>
        <Copyright />
      </Grid>
    </Grid>
  );
};

const hasReachedComplete = (state, questionId) => {
  return get(state, ["payload", "answer", questionId, "duration"], null) === 0;
}

const mapStateToProps = state => ({
  content: getPageContent(state, OUTRO_PAGE),
  survey: get(state, ["survey", "name"]),
  locale: get(state, ["i18n", "locale"], "en"),
  member_id: get(state, ["meta", "member_id"], ""),
  ext_uuid: get(state, ["meta", "ext_uuid"], ""),
  questionId: get(
    state,
    ["cursor", "path", get(state, ["cursor", "index"])],
    ""
  ),
  completed: hasReachedComplete(state, "MRK_REF1")
    || hasReachedComplete(state, "MRK_REF2")
    || hasReachedComplete(state, "END_QLF1")
    || hasReachedComplete(state, "END_QLF2")
    || hasReachedComplete(state, "MRK_QLF1")
    || hasReachedComplete(state, "MRK_QLF2")
    || hasReachedComplete(state, "MRK_FB1")
});

export default connect(mapStateToProps)(withStyles(styles)(OutroPage));
